//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    logTimeLine: {
      type: Number,
      default: 30,
    },
  },
  data() {
    return {
      formValue: {
        days: 30,
      },
    };
  },
  computed: {},
  watch: {
    logTimeLine(val) {
      this.formValue.days = val;
    },
    visible(val) {
      if (val) {
        this.formValue.days = this.logTimeLine;
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$refs.timeForm.clearValidate();
      this.$emit('close');
    },
    submit() {
      this.$refs.timeForm.validate(async (valid) => {
        if (!valid) return;
        try {
          this.$emit('setProcessLogConfigure', this.formValue.days);
          this.close();
        } catch (err) {
          console.warn('setTimeErr', err);
        }
      });
    },
  },
};
